var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCurationRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 2 \\u2013 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 14",
    style: {
      fill: "rgba(0,0,0,.15)",
      stroke: "#ddd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h39v39H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1",
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    },
    transform: "rotate(90 12.5 20.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2",
    d: "m8 11 6-6 6 6",
    transform: "rotate(90 11.5 17.5)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurationRightArrow);
export default __webpack_public_path__ + "static/media/icon-curation-rightArrow.7e8315a2.svg";
export { ForwardRef as ReactComponent };